// extracted by mini-css-extract-plugin
module.exports = {"verticalTilesSlider":"VerticalTilesBlock_verticalTilesSlider__BLQ_T"};